import type { RouteRecordRaw } from 'vue-router'

import type { RedirectRouteRelative } from '@/utilities/routers'

import { routeConnectedAppRoot } from './connectedAppRoutes'
import { routeEmailAccountRoot } from './emailAccountRoutes'
import {
  routeEmailConfigurationHome,
  routeEmailConfigurationRoot,
} from './emailConfigurationRoutes'
import { routeEmailDomainRoot } from './emailDomainRoutes'
import { routeEmailTemplateRoot } from './emailTemplateRoutes'
import { routeTokenCacheRoot } from './tokenCacheRoutes'

const routeEmailSettingsHome: RouteRecordRaw = routeEmailConfigurationHome

const routeEmailSettingsRoot: RouteRecordRaw = {
  children: [
    routeEmailSettingsHome,
    routeConnectedAppRoot,
    routeEmailAccountRoot,
    routeEmailDomainRoot,
    routeEmailTemplateRoot,
    routeConnectedAppRoot,
    routeEmailConfigurationRoot,
    routeTokenCacheRoot,
  ],
  path: 'email',
}

const redirectEmailSettings: RedirectRouteRelative = {
  name: routeEmailSettingsHome.name,
}

export { redirectEmailSettings, routeEmailSettingsHome, routeEmailSettingsRoot }
